import Vue from 'vue';

class AssetsService {
  constructor() {}

  getAssetsByType() {
    return Vue.localStorage.get('assets');
  }

  getAssets() {
    return Vue.localStorage.get('allAssets');
  }

  getProductSlidesName(product) {
    const reg = /.jpg/g;

    return product.slides.map(slide => slide.replace(reg, ''));
  }
}

export default new AssetsService();
